import styled from 'styled-components';

const SecondaryFormWrapper = styled.div`
  .ant-input {
    font-family: regular_medium;
  }
`;

export default SecondaryFormWrapper;


// WEBPACK FOOTER //
// ./src/components/IC/SecondaryForm/SecondaryFormWrapper.style.js